import React from "react";

import { LinkHandler } from "@/components/common/LinkHandler";
import Tag from "@/components/common/Tag/Tag";
import { ArrowRightNav } from "@/components/icons/ArrowRightNav";
import RggMenNavBanner2 from "@/components/lp/rgg/Nav/RggMenNavBanner2";
import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import { TextElementMen } from "@/components/ui-kit/TextElementMen/TextElementMen";
import { HeaderDataItem } from "@/data/navigation/header.data";
import { useNavigation } from "@/hooks/useNavigation";
import { PromoData } from "@/types/promoData";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

import styles from "./MenNavigationShop.module.scss";
import MenNavigationShopSubCategory from "./MenNavigationShopSubCategory";
import MlbMenNavBanner, { mlbBanner } from "./MlbMenNavBanner";
import PromoSaleBanner from "./PromoSaleBanner";
interface MenNavigationShopContentProps {
  item: HeaderDataItem;
  navigate?: ReturnType<typeof useNavigation>;
  promoCf?: PromoData;
}

const trackClicked = (text: string, destination: string) => {
  GA4.onNavigationClicked({
    type: "button",
    text,
    destination,
  });
};

const MenNavigationShopContent: React.FC<MenNavigationShopContentProps> = ({
  item,
  navigate,
  promoCf,
}) => {
  const promoBanner = promoCf?.savingsData?.web?.nav?.men;

  return (
    <div className="flex flex-col w-full p-10 gap-10">
      <div className={cn("flex flex-row items-stretch gap-16", "gap-4 xl:gap-8 2xl:gap-16")}>
        {/* Core Products Column */}
        <div className={cn("w-[340px] xl:w-[406px]")}>
          <div className="bg-nova-brand-darkblue-60 rounded py-8">
            <h3 className="mb-4 px-8">
              <TextElementMen
                text={item.childrenTitle}
                className={`text-nova-base-white Title-10-Super-Normal`}
              />
            </h3>
            <ul className={cn("flex flex-col")}>
              {item.children
                ?.filter((el) => el.mode === "core")
                .map((child, index) => (
                  <li
                    key={index}
                    className={cn(
                      "group hover:bg-nova-base-solid-20 transition-colors",
                      child.className,
                      styles.navLink,
                      `shop-nav-idx-${index}`
                    )}
                  >
                    <LinkHandler
                      path={child.url}
                      className={cn("py-10 block mx-8", child.className)}
                      onClick={() => trackClicked(child.title, child.url)}
                    >
                      <div className={`flex  items-center`}>
                        <div className={`flex gap-2 items-center`}>
                          <TextElementMen
                            text={child.title}
                            className="text-nova-base-white group-hover:text-nova-base-black transition-colors Body-20-Dia-Strong"
                          />
                          <div>
                            <Tag
                              data={{
                                line: child.subtext,
                                classes: "bg-nova-brand-accent-80",
                              }}
                            />
                          </div>
                        </div>
                        <div className={`ml-auto invisible group-hover:visible`}>
                          <ArrowRightNav className={` text-nova-base-white rounded w-6 h-6`} />
                        </div>
                      </div>
                    </LinkHandler>
                  </li>
                ))}
            </ul>
          </div>
          <div className="flex flex-col gap-[10px] mt-6">
            <ButtonNova
              icon={`Right`}
              level={`Primary`}
              label="Shop All Products"
              width={`100%`}
              className="w-full inline-flex items-center justify-center !py-4"
              trackObject={{
                destination: "/hair/men/product/category/",
                name: "Navigation Clicked",
                module_location: "navigation",
              }}
              onClick={() => {
                navigate("/hair/men/product/category/");
              }}
            />
            <ButtonNova
              icon={`Right`}
              level={`Secondary`}
              label="Find Your Routine"
              width={`100%`}
              className="w-full inline-flex items-center justify-center !py-4"
              trackObject={{
                destination: "/hair/brand/quiz/",
                name: "Navigation Clicked",
                module_location: "navigation",
              }}
              onClick={() => {
                navigate("/hair/brand/quiz/");
              }}
            />
          </div>
        </div>
        {/* Root Causes Column */}
        <div className={"w-[240px] xl:w-[273px]"}>
          <MenNavigationShopSubCategory item={item} />
        </div>
        {/* RGG Banner Column */}
        <div className={cn("flex", mlbBanner ? "w-[273px]" : "w-[280px] xl:w-[356px]")}>
          {mlbBanner ? (
            <MlbMenNavBanner layout="card" className="h-full w-full" />
          ) : promoBanner ? (
            <PromoSaleBanner data={promoBanner} />
          ) : (
            <RggMenNavBanner2 className="h-full w-full" />
          )}
        </div>
      </div>
    </div>
  );
};

export default MenNavigationShopContent;
